import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { environment } from "../../config/environment";

const CustomLink = ({ to, className, children, ...rest }) => {
  const excludedPaths = ["/category/recently-played"];
  let href = to;

  if (!excludedPaths.includes(to)) {
    if (to === "/") {
      href = environment.AARP_PROD_HOST + '/';
    } else if (to.startsWith("/category/")) {
      href = environment.AARP_PROD_HOST + `${to}/`;
    }
  }

  if (href.startsWith("http")) {
    return (
      <a href={href} className={className} {...rest}>
        {children}
      </a>
    );
  } else {
    return (
      <RouterLink to={href} className={className} {...rest}>
        {children}
      </RouterLink>
    );
  }
};

export default CustomLink;
